// src/pages/ResetPasswordPage.jsx
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../api/client';
import './ResetPasswordPage.css';

export default function ResetPasswordPage() {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [newPassword1, setNewPassword1] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setInfo(null);

    if (!newPassword1.trim() || !newPassword2.trim()) {
      setError('Ambos campos son obligatorios.');
      return;
    }
    if (newPassword1 !== newPassword2) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      await API.post('/auth/reset-password-confirm/', {
        uid: uid,
        token: token,
        new_password1: newPassword1,
        new_password2: newPassword2
      });
      setInfo('Contraseña cambiada correctamente. Redirigiendo al login…');
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Error al cambiar la contraseña.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-overlay">
      <div className="reset-card">
        <button className="modal-close" onClick={() => navigate('/')}>×</button>

        <form onSubmit={handleSubmit} className="form">
          <h3 className="reset-title">Restablecer contraseña</h3>
          {error && <div className="error">{error}</div>}
          {info && <div className="success">{info}</div>}

          {!info && (
            <>
              <div className="form-group relative">
                <label>
                  Nueva contraseña <span className="required">*</span>:
                </label>
                <input
                  type={showPassword1 ? 'text' : 'password'}
                  value={newPassword1}
                  onChange={(e) => setNewPassword1(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowPassword1(!showPassword1)}
                  tabIndex={-1}
                >
                  {showPassword1 ? '🙈' : '👁️'}
                </button>
              </div>

              <div className="form-group relative">
                <label>
                  Confirmar contraseña <span className="required">*</span>:
                </label>
                <input
                  type={showPassword2 ? 'text' : 'password'}
                  value={newPassword2}
                  onChange={(e) => setNewPassword2(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-btn"
                  onClick={() => setShowPassword2(!showPassword2)}
                  tabIndex={-1}
                >
                  {showPassword2 ? '🙈' : '👁️'}
                </button>
              </div>

              <button type="submit" className="btn" disabled={loading}>
                {loading ? 'Cambiando...' : 'Cambiar contraseña'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
